import { Injectable, Optional } from "@angular/core";
import {ScreenOrientation} from '@awesome-cordova-plugins/screen-orientation/ngx'
import { Platform } from "@ionic/angular";
import { Subject } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class ScreenRotatableService {
    onChange = new Subject();

    constructor(
        @Optional() private screen: ScreenOrientation,
        private platform: Platform
    ) {
        this.platform.ready().then(() => {
            if (this.platform.is('cordova')){
                this.screen.onChange().subscribe((data) => {
                    this.onChange.next(data);
                });
            }else{
                console.log('platform is not cordova')
            }
        })
    }

    lockPortraitOrientation() {
        if (!this.platform.is('cordova')) return;

        // screen.lock(screen.ORIENTATIONS.PORTRAIT).then(() => {
        this.screen.lock(this.screen.ORIENTATIONS.PORTRAIT).then(() => {
            console.log('The screen orientation has changed to portrait.');
        }).catch(err => {
            console.log('Error while changing the screen orientation, ' + err);
        });
    }

    unlock() {
        // screen.unlock()
        this.screen.unlock();
        console.log('The screen orientation has changed to any')
    }

    getOrientationType() {
        return this.screen.type;
        // return screen.type;
    }
}